import api from './api';

export const accountService = {
  /**
   * Listar todas as contas
   */
  getAll: async () => {
    const response = await api.get('/accounts');
    return response;
  },

  /**
   * Buscar conta por ID
   */
  getById: async (accountId) => {
    const response = await api.get(`/accounts/${accountId}`);
    return response;
  },

  /**
   * Criar nova conta
   */
  create: async (data) => {
    const response = await api.post('/accounts', data);
    return response;
  },

  /**
   * Atualizar conta
   */
  update: async (accountId, data) => {
    const response = await api.put(`/accounts/${accountId}`, data);
    return response;
  },

  /**
   * Excluir conta
   */
  delete: async (accountId) => {
    const response = await api.delete(`/accounts/${accountId}`);
    return response;
  },

  /**
   * Transferir entre contas
   */
  transfer: async (data) => {
    const response = await api.post('/accounts/transfer', data);
    return response;
  },
};

export default accountService;
